import { Component, Vue, Watch as watch } from 'nuxt-property-decorator';
import { mapState } from 'vuex';

@Component({
    components: {
        // Collapse: require('~/components/common/collapse').default,
        popup: require('~/components/ui/dialog').default,
        sberbankInfo: require('./sberbank').default,
        creditInfo: require('./credit').default,
    },
    computed: mapState(['region']),
})
export default class DeliveryPageComponent extends Vue {

    public region: Store.CurrentRegion;

    public deliveryInfo: any[] = null;
    public textParts = null;
    public meta: Descriptions;
    private showSberbank = false;
    private showCredit = false;

    get hasEMoney() {
        return this.region.payTypes.findIndex((el) => el.id === 6) !== -1;
    }

    get hasCash() {
        return this.region.payTypes.findIndex((el) => el.id === 1) !== -1;
    }

    get hasCredit() {
        return this.region.payTypes.findIndex((el) => el.id === 10) !== -1;
    }

    get hasSberbank() {
        return this.region.payTypes.findIndex((el) => el.id === 19) !== -1;
    }

    get deliveryTime() {
        return this.region.code === 'belgorod.triya.ru' ? '7 до 14 дней' : '5 до 10 дней';
    }

    public head() {
        return {
            title: this.meta.title,
            meta: [
                { vmid: 'description', name: 'description', content: this.meta.description }
            ]
        };
    }

    public async asyncData({ store }) {
        const data =  await store.dispatch('data/FetchDeliveryInfo');

        return {
            deliveryInfo: data.table,
            textParts: data.text,
            meta: data.meta,
        };

    }

    @watch('region')
    public async onRegionChange() {
        let data = await this.$store.dispatch('data/FetchDeliveryInfo');
        this.deliveryInfo = data.table;
        this.textParts = data.text;
        this.meta = data.meta;
    }
}
